'use client'
import { ArrowRight } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

const Button = ({ link, text, paragraph }) => {
    return (

        <div className="w-full flex flex-col md:flex-row gap-0 md:gap-3 justify-between items-center py-4">
            <p className={`text-[16px] md:text-[22px] font-semibold mb-4 md:mb-0`}>
                {paragraph}
            </p>
            <Link href={link} id="btn-apply-now-mid" className="btn-wrap link_btn flex items-center justify-center p-4 w-full gap-2 transition-all duration-300 text-[16px] whitespace-nowrap text-center">
                    {text}
                <span className="relative inline-flex h-5 w-5 overflow-hidden">
                    {/* Arrow currently visible */}
                    <span className="arrow arrow--out material-symbols-outlined text-lg leading-none">
                        <ArrowRight />
                    </span>
                </span>
            </Link>
            
        </div>

    )
}

export default Button